import ConfigView from "../ConfigView.vue";
import ClusterList from "../Pages/ClusterList.vue";
import ClusterEditor from "../Pages/ClusterEditor.vue";
import ZonalList from "../Pages/ZonalList.vue";
import ZonalEditor from "../Pages/ZonalEditor.vue";
import TypeList from "../Pages/TypeList.vue";
import TypeEditor from "../Pages/TypeEditor.vue";

const routes = [
  {
    path: "mantenimiento",
    component: ConfigView,
    name: "config",
    children: [
      {
        path: "clusters",
        name: "celulares-config-cluster-list",
        roles: ['mantenimiento_clusters'],
        component: ClusterList,
      },
      {
        path: "clusters/crear",
        name: "celulares-config-cluster-create",
        roles: ['mantenimiento_clusters_agregar'],
        component: ClusterEditor,
      },
      {
        path: "clusters/:id/editar",
        name: "celulares-config-cluster-edit",
        roles: ['mantenimiento_clusters_editar'],
        component: ClusterEditor,
      },
      {
        path: "zonales",
        name: "celulares-config-zonal-list",
        roles: ['mantenimiento_zonales'],
        component: ZonalList
      },
      {
        path: "zonales/crear",
        name: "celulares-config-zonal-create",
        roles: ['mantenimiento_zonales_agregar'],
        component: ZonalEditor
      },
      {
        path: "zonales/:id/editar",
        name: "celulares-config-zonal-edit",
        roles: ['mantenimiento_zonales_editar'],
        component: ZonalEditor,
      },
      {
        path: "tipos",
        name: "celulares-config-types-list",
        roles: ['mantenimiento_tipos'],
        component: TypeList
      },
      {
        path: "tipos/crear",
        name: "celulares-config-types-create",
        roles: ['mantenimiento_tipos_agregar'],
        component: TypeEditor
      },
      {
        path: "tipos/:id/editar",
        name: "celulares-config-types-edit",
        roles: ['mantenimiento_tipos_editar'],
        component: TypeEditor
      }
    ],
  },
];

export default routes;
